module.exports = __webpack_public_path__ + "static/media/v42.0d92e723.mp4";